import React from 'react';
import { normalizeFreeItem } from './restaurant-delivery-map/restaurantDeliveryOrderHelpers';

const PickupFreeItemNotice = ({ order }) => {
  const freeItems = normalizeFreeItem(order);

  if (!freeItems.length) {
    return null;
  }

  return (
    <section className='action-order-detail__pickup-free'>
      <h3 className='action-order-detail__section-title'>Pickup free item</h3>
      <div className='action-order-detail__pickup-free-list'>
        {freeItems.map((item, index) => (
          <div className='action-order-detail__pickup-free-row' key={`pickup-free-${index}`}>
            <span className='action-order-detail__qty'>1</span>
            <div className='action-order-detail__item-body'>
              <div className='action-order-detail__item-name'>{item.name}</div>
              <div className='action-order-detail__item-tag'>Included free</div>
            </div>
            <div className='action-order-detail__item-price'>Free</div>
          </div>
        ))}
      </div>
      <p className='action-order-detail__pickup-free-note'>
        Complimentary pickup item — please include this free item with the order.
      </p>
    </section>
  );
};

export default PickupFreeItemNotice;
